var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/message-question"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/message-question_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "message-question"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.6641 24.5734H17.3307L11.3974 28.52C10.5174 29.1067 9.33073 28.4801 9.33073 27.4134V24.5734C5.33073 24.5734 2.66406 21.9067 2.66406 17.9067V9.90666C2.66406 5.90666 5.33073 3.23999 9.33073 3.23999H22.6641C26.6641 3.23999 29.3307 5.90666 29.3307 9.90666V17.9067C29.3307 21.9067 26.6641 24.5734 22.6641 24.5734Z",
    stroke: "#0082CD",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.0024 15.1467V14.8668C16.0024 13.9601 16.5624 13.4801 17.1224 13.0934C17.6691 12.7201 18.2157 12.2401 18.2157 11.3601C18.2157 10.1334 17.229 9.14673 16.0024 9.14673C14.7757 9.14673 13.7891 10.1334 13.7891 11.3601",
    stroke: "#0082CD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.9966 18.3334H16.0086",
    stroke: "#0082CD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.ba8d9669e0f92bcf87217fe80675a376.svg";
export { ForwardRef as ReactComponent };